module.exports = __webpack_public_path__ + "img/HC3P_Carrousel_7.fc89c80a.jpg";